<template>
  <div>
    <Modal
      v-model="showModal"
      size="tiny"
      :close="false"
      title=""
      titleAlign="center"
    >
      <div class="text-center">
        <div class="mb-4">
          <img src="../../assets/themes/clipp360/images/logo.png" height="80" />
        </div>
        <p v-if="isPlan360">Você possuí o plano <b>Clipp360</b></p>
        <p v-else>Você não possuí o plano <b>Clipp360</b></p>
        <p>
          Iremos te redirecionar para a página correta em alguns instantes{{
            dots
          }}
        </p>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { removeToken } from '@/configurations/token';
import Modal from '../Modal';
import {
  RANKING_RESELLER_BRONZE,
  RANKING_RESELLER_SILVER,
  RANKING_RESELLER_GOLD,
  RANKING_RESELLER_BLACK,
  RANKING_RESELLER_DIAMOND,
} from './rankingResellerEnums';

export default {
  components: {
    Modal,
  },
  name: 'Redirect360',
  computed: {
    ...mapState('subscription', ['subscription']),
    isLoading() {
      return this.loading || this.loadingInit;
    },
  },
  mounted() {
    this.verifyIfRedirect();
  },
  data() {
    return {
      isPlan360: false,
      showModal: false,
      clipp360SubscriptionId: 25,
      ordemClipp360SubscriptionId: 26,
      clippReseller: 7,
      clippTrialId: 6,
      numberOfDots: 1,
      rankingResellerPermited: [
        RANKING_RESELLER_BLACK,
        RANKING_RESELLER_DIAMOND,
        RANKING_RESELLER_GOLD,
        RANKING_RESELLER_SILVER,
        RANKING_RESELLER_BRONZE,
      ],
      dots: '.',
    };
  },
  methods: {
    ...mapActions('subscription', ['setSubscription']),
    async verifyIfRedirect() {
      this.changeDots();
      let { paymentMode } = this.subscription || { paymentMode: null };

      if (!paymentMode) {
        paymentMode = (await this.setSubscription()).paymentMode;
      }

      const { id: subscriptionId } = paymentMode;
   
      this.isPlan360 =
        this.clipp360SubscriptionId === subscriptionId ||
        this.ordemClipp360SubscriptionId === subscriptionId ||
        this.clippTrialId === subscriptionId ||
        this.clippReseller === subscriptionId;

      if (
        this.isPlan360 &&
        window.location.origin === process.env.VUE_APP_BASE_URL_360
      ) {
        return;
      }

      if (
        this.isPlan360 &&
        window.location.origin !== process.env.VUE_APP_BASE_URL_360
      ) {
        this.showModal = true;
        this.redirectTimeOut();
        return;
      }

      if (
        !this.isPlan360 &&
        window.location.origin === process.env.VUE_APP_BASE_URL_360
      ) {
        this.showModal = true;
        this.redirectTimeOut(process.env.VUE_APP_BASE_URL);
      }
    },
    redirectTimeOut(host = process.env.VUE_APP_BASE_URL_360, time = 8000) {
      return setTimeout(() => {
        removeToken();
        const { location } = window;
        location.href = `${host}/v2.html${location.hash}`;
      }, time);
    },
    changeDots(time = 1000) {
      return setInterval(() => {
        this.dots += '.';
        this.numberOfDots += 1;

        if (this.numberOfDots > 3) {
          this.dots = '.';
          this.numberOfDots = 1;
        }
      }, time);
    },
  },
};
</script>
